import React from 'react'
import AboutComponent from '../about/AboutComponent';
import Footer from '../common/footer/Footer';
import Hero from '../common/hero/Hero';
import Navbar from '../common/navbar/Navbar';
import ContactComponent from '../contact/ContactComponent';
import ProjectsComponent from '../projects/ProjectsComponent';
import ServicesComponent from '../services/ServicesComponent';

const Home = () => {
  return (
    <div>
      <Navbar/>
      <Hero/>
      <AboutComponent/>
      <ServicesComponent/>
      <ProjectsComponent/>
      <ContactComponent/>
      <Footer/>
    </div>
  )
}

export default Home;